module.exports = __webpack_public_path__ + "img/pencetak-buku.d54d9015.svg";